
import Component from "vue-class-component"
import AbstractPage from "@/report/pages/AbstractPage.vue"
import BiSectionPage from "@/report/pages/BiSectionPage.vue"

@Component({name: "CustomBiSectionPage", components: {BiSectionPage}})
export default class CustomBiSectionPage extends AbstractPage {}
